// extracted by mini-css-extract-plugin
module.exports = {"day__title":"styles_day__title__nlE5V"};